import { defineElement } from '@umbraco-ui/uui-base/lib/registration';
import { UUICardElement } from '@umbraco-ui/uui-card/lib';
import { css, nothing, html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _UUICardBlockTypeElement_instances, renderButton_fn, renderLink_fn, renderMedia_fn, renderContent_fn;
let UUICardBlockTypeElement = class extends UUICardElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _UUICardBlockTypeElement_instances);
    this.name = "";
  }
  get background() {
    return void 0;
  }
  set background(value) {
    this.style.backgroundColor = value ?? "";
  }
  render() {
    return html`
      ${__privateMethod(this, _UUICardBlockTypeElement_instances, renderMedia_fn).call(this)}
      ${this.href ? __privateMethod(this, _UUICardBlockTypeElement_instances, renderLink_fn).call(this) : __privateMethod(this, _UUICardBlockTypeElement_instances, renderButton_fn).call(this)}
      <!-- Select border must be right after #open-part -->
      <div id="select-border"></div>
      ${this.selectable ? this.renderCheckbox() : nothing}
      <slot name="tag"></slot>
      <slot name="actions"></slot>
    `;
  }
};
_UUICardBlockTypeElement_instances = new WeakSet();
renderButton_fn = function() {
  const tabIndex = !this.disabled ? this.selectOnly ? -1 : 0 : void 0;
  return html`
      <button
        id="open-part"
        class="uui-text"
        tabindex=${ifDefined(tabIndex)}
        @click=${this.handleOpenClick}
        @keydown=${this.handleOpenKeydown}>
        ${__privateMethod(this, _UUICardBlockTypeElement_instances, renderContent_fn).call(this)}
      </button>
    `;
};
renderLink_fn = function() {
  const tabIndex = !this.disabled ? this.selectOnly ? -1 : 0 : void 0;
  const rel = this.target === "_blank" ? "noopener noreferrer" : void 0;
  return html`
      <a
        id="open-part"
        class="uui-text"
        tabindex=${ifDefined(tabIndex)}
        href=${ifDefined(!this.disabled ? this.href : void 0)}
        target=${ifDefined(this.target || void 0)}
        rel=${ifDefined(this.rel || rel)}>
        ${__privateMethod(this, _UUICardBlockTypeElement_instances, renderContent_fn).call(this)}
      </a>
    `;
};
renderMedia_fn = function() {
  return html`<div id="portrait">
      <slot></slot>
    </div> `;
};
renderContent_fn = function() {
  return html`
      <div id="content">
        <span title="${this.name}" id="name">${this.name}</span>
        <small title="${ifDefined(this.description)}">${this.description}<slot name="description"></slot></small>
      </div></div>
    `;
};
UUICardBlockTypeElement.styles = [
  ...UUICardElement.styles,
  css`
      :host {
        background-color: var(--uui-color-surface-alt,#f3f3f5);
      }

      slot[name='tag'] {
        position: absolute;
        bottom: var(--uui-size-4,12px);
        right: var(--uui-size-4,12px);
        display: flex;
        justify-content: right;
        z-index: 2;
      }

      slot[name='actions'] {
        position: absolute;
        top: var(--uui-size-4,12px);
        right: var(--uui-size-4,12px);
        display: flex;
        justify-content: right;
        z-index: 2;
        opacity: 0;
        transition: opacity 120ms;
      }
      :host(:focus) slot[name='actions'],
      :host(:focus-within) slot[name='actions'],
      :host(:hover) slot[name='actions'] {
        opacity: 1;
      }

      #portrait {
        display: flex;
        justify-content: center;
        min-height: 150px;
        max-height: 150px;
        width: 100%;
        margin-bottom: var(--uui-size-layout-2,30px);
      }

      slot:not([name])::slotted(*) {
        align-self: center;
        border-radius: var(--uui-border-radius,3px);
        object-fit: cover;
        max-width: 100%;
        max-height: 100%;
        font-size: var(--uui-size-8,24px);
      }

      #open-part {
        position: absolute;
        z-index: 1;
        inset: 0;
        color: var(--uui-color-interactive,#1b264f);
        border: none;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
      }

      :host([disabled]) #open-part {
        pointer-events: none;
        background: var(--uui-color-disabled,#f3f3f5);
        color: var(--uui-color-contrast-disabled);
      }

      #open-part:hover {
        color: var(--uui-color-interactive-emphasis,#3544b1);
      }
      #open-part:hover #name {
        text-decoration: underline;
      }
      #open-part #name,
      #open-part small {
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        overflow-wrap: anywhere;
      }

      :host([image]:not([image=''])) #open-part {
        transition: opacity 0.5s 0.5s;
        opacity: 0;
      }

      #content {
        position: relative;
        display: flex;
        flex-direction: column;
        width: 100%;
        font-family: inherit;
        font-size: var(--uui-type-small-size,12px);
        box-sizing: border-box;
        text-align: left;
        word-break: break-word;
        padding-top: var(--uui-size-space-3,9px);
      }

      #content::before {
        content: '';
        position: absolute;
        inset: 0;
        z-index: -1;
        border-top: 1px solid var(--uui-color-divider,#f6f6f7);
        border-radius: 0 0 var(--uui-border-radius,3px) var(--uui-border-radius,3px);
        background-color: var(--uui-color-surface,#fff);
        pointer-events: none;
        opacity: 0.96;
      }

      :host(:focus) slot[name='actions'],
      :host(:focus-within) slot[name='actions'],
      :host(:hover) slot[name='actions'] {
        opacity: 1;
      }

      :host(
          [image]:not([image='']):hover,
          [image]:not([image='']):focus,
          [image]:not([image='']):focus-within,
          [selected][image]:not([image='']),
          [error][image]:not([image=''])
        )
        #open-part {
        opacity: 1;
        transition-duration: 120ms;
        transition-delay: 0s;
      }

      :host([selectable]) #open-part {
        inset: var(--uui-size-space-3,9px) var(--uui-size-space-4,12px);
      }
      :host(:not([selectable])) #content {
        padding: var(--uui-size-space-3,9px) var(--uui-size-space-4,12px);
      }
      :host([selectable]) #content::before {
        inset: calc(var(--uui-size-space-3,9px) * -1)
          calc(var(--uui-size-space-4,12px) * -1);
        top: 0;
      }
    `
];
__decorateClass([
  property({ type: String })
], UUICardBlockTypeElement.prototype, "name", 2);
__decorateClass([
  property({ type: String })
], UUICardBlockTypeElement.prototype, "description", 2);
__decorateClass([
  property({ type: String, attribute: "background" })
], UUICardBlockTypeElement.prototype, "background", 1);
UUICardBlockTypeElement = __decorateClass([
  defineElement("uui-card-block-type")
], UUICardBlockTypeElement);

export { UUICardBlockTypeElement };
